import apiService from '@/state/services/Api'
import charts from './reportCharts'

const reports = {
  namespaced: true,
  modules: {
    charts,
  },
  state: {
    cached: [],
    types: {
      totalVolume: 1,
      delta: 2,
    },
  },
  getters: {
    types(state) {
      return state.types
    },

    afm(state) {
      return {...state.types, ...{flow: 3, meanVelocity: 4, sensorStatus: 5}}
    },

    lora(state) {
      return {...state.types, ...{spreadFactor: 6}}
    },
  },
  mutations: {},
  actions: {
    getAlerts({state, commit}, meter) {
      return apiService.get(`installations/${meter.uuid}/alerts/`)
    },

    getState({state, commit}, meter) {
      return apiService.get(`installations/${meter.uuid}/state/`)
    },

    getTotal({state, commit, rootState}) {
      const company = rootState.route?.query?.company
      const queryParam = company
        ? `installations/total/?company=${company}`
        : `installations/total/`
      return apiService.get(`${queryParam}`).then(data => data)
    },

    getMeasurements({state, commit, rootState, rootGetters}) {
      const company = rootState.route?.query?.company
      const queryParam = company
        ? `installations/?company=${company}&limit=9999&offset=0`
        : rootGetters['auth/isUser']
        ? `installations/?limit=9999&offset=0`
        : `installations/`

      return apiService.get(`${queryParam}`).then(data => data.results)
    },

    // ---------------------------------------------------------------------------------------------------------

    getTotalVolume({state, commit}, obj) {
      return apiService
        .get(`installations/${obj.meter_uuid}/reports/`, {
          params: {...obj.params, type: 'total_volume'},
        })
        .then(data => {
          return data
        })
    },

    getDeltaVolume({state, commit}, obj) {
      return apiService
        .get(`installations/${obj.meter_uuid}/reports/`, {
          params: {...obj.params, type: 'delta_volume'},
        })
        .then(data => {
          return data
        })
    },

    getFlow({state, commit}, obj) {
      return apiService
        .get(`installations/${obj.meter_uuid}/reports/`, {params: {...obj.params, type: 'flow'}})
        .then(data => {
          return data
        })
    },

    getMeanVelocity({state, commit}, obj) {
      return apiService
        .get(`installations/${obj.meter_uuid}/reports/`, {
          params: {...obj.params, type: 'mean_velocity'},
        })
        .then(data => {
          return data
        })
    },

    getSensorStatus({state, commit}, obj) {
      return apiService
        .get(`installations/${obj.meter_uuid}/reports/`, {
          params: {...obj.params, type: 'sensor_status'},
        })
        .then(data => {
          return data
        })
    },

    getSpreadFactor({state, commit}, obj) {
      return apiService
        .get(`installations/${obj.meter_uuid}/reports/`, {
          params: {...obj.params, type: 'spread_factor'},
        })
        .then(data => {
          return data
        })
    },

    getTemperature({state, commit}, obj) {
      return apiService
        .get(`installations/${obj.meter_uuid}/reports/`, {
          params: {...obj.params, type: 'temperature'},
        })
        .then(data => {
          return data
        })
    },

    getBatteryVoltage({state, commit}, obj) {
      return apiService
        .get(`installations/${obj.meter_uuid}/reports/`, {
          params: {...obj.params, type: 'battery_voltage'},
        })
        .then(data => {
          return data
        })
    },

    getBatteryLifetime({state, commit}, obj) {
      return apiService
        .get(`installations/${obj.meter_uuid}/reports/`, {
          params: {...obj.params, type: 'battery_lifetime'},
        })
        .then(data => {
          return data
        })
    },

    getBattery1Status({state, commit}, obj) {
      return apiService
        .get(`installations/${obj.meter_uuid}/reports/`, {
          params: {...obj.params, type: 'battery1_status'},
        })
        .then(data => {
          return data
        })
    },

    getBattery2Status({state, commit}, obj) {
      return apiService
        .get(`installations/${obj.meter_uuid}/reports/`, {
          params: {...obj.params, type: 'battery2_status'},
        })
        .then(data => {
          return data
        })
    },

    getLevel1({state, commit}, obj) {
      return apiService
        .get(`installations/${obj.meter_uuid}/reports/`, {params: {...obj.params, type: 'level_1'}})
        .then(data => {
          return data
        })
    },

    exportAll({state, commit, rootState}, {params, format}) {
      const config = {responseType: 'blob'}
      config.timeout = 100000

      if (format === 'json') {
        config.headers = {Accept: 'application/json; indent=4'}
      }
      if (format === 'xml') {
        config.headers = {Accept: 'application/xml; charset=utf-8'}
      }
      if (format === 'csv') {
        config.headers = {Accept: 'text/csv; charset=utf-8'}
      }
      let dateAfter = params.date_after
      config.params = {
        serial: params.serial_number,
        datetime_after: dateAfter,
        datetime_before: params.date_before,
      }
      return apiService.get(`v1/readouts.${format}`, config).then(data => {
        return data
      })
    },

    exportAfm({state, commit, rootState}, {params, format}) {
      const config = {responseType: 'blob'}
      config.timeout = 100000

      if (format === 'json') {
        config.headers = {Accept: 'application/json; indent=4'}
      }
      if (format === 'xml') {
        config.headers = {Accept: 'application/xml; charset=utf-8'}
      }
      if (format === 'csv') {
        config.headers = {Accept: 'text/csv; charset=utf-8'}
      }
      let dateAfter = params.date_after.substring(0, 10)
      config.params = {
        serial_number: params.serial_number,
        date_after: dateAfter,
      }
      return apiService.get(`reports/exports/afm.${format}`, config).then(data => {
        return data
      })
    },
  },
}

export default reports
